import { call, fork, put, takeEvery } from 'redux-saga/effects';

import AccountUserApi from '../../../../lib/api/account/user/AccountUserApi';
import toastMsg from '../../../../lib/toastMsg';
import accountUserActions from './actions';
import accountUserToastMsg from '../../../../constants/service/toastMsg/accountUserToastMsg';
import { excelDownLoad, setRequestForm, setResponseListForm } from '../../../../lib/common';
import { setTimelineRequestPayload } from '../../../../lib/utils/userUtils';

function* fetchList() {
  /**
   *  [유저] 유저 리스트 요청하기
   */
  yield takeEvery(accountUserActions.GET_USER_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(AccountUserApi.getAccountUserList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(accountUserToastMsg.GET_USER_LIST_REQUEST_SUCCESS);

        const data = {
          accountUserList: setResponseListForm(result.data.accountUserList, result.data.totalCnt, payload),
        };
        yield put({ type: accountUserActions.GET_USER_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(accountUserToastMsg.GET_USER_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [유저] 유저 랭크 리스트 요청하기
   */
  yield takeEvery(accountUserActions.GET_USER_RANK_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(AccountUserApi.getAccountUserRankList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(accountUserToastMsg.GET_USER_RANK_LIST_REQUEST_SUCCESS);

        const data = {
          accountUserRankList: setResponseListForm(result.data.accountUserRankList, result.data.totalCnt, payload),
        };
        yield put({ type: accountUserActions.GET_USER_RANK_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(accountUserToastMsg.GET_USER_RANK_LIST_REQUEST_ERROR);
    }
  });

  /**
   *  [유저] 유저 랭킹 리스트 excel 다운로드 하기
   */
  yield takeEvery(accountUserActions.GET_USER_RANK_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(AccountUserApi.getAccountUserRankExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(accountUserToastMsg.GET_USER_RANK_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad(payload.userPageName, result.data.userRankListExcelSheet);
      }
    } catch (error) {
      toastMsg.error(accountUserToastMsg.GET_USER_RANK_EXCEL_DOWNLOAD_REQUEST_ERROR);
    }
  });

  /**
   * [유저] 유저 상세 정보 중 태그 타임라인 리스트 요청하기
   */
  yield takeEvery(accountUserActions.GET_USER_DETAIL_TAG_LOG_LIST_REQUEST, function* ({ payload }) {
    try {
      const customPayload = setTimelineRequestPayload(payload, 'tagLogHistory');

      const result = yield call(AccountUserApi.getAccountUserDetailTagLogList, setRequestForm(customPayload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(accountUserToastMsg.GET_USER_DETAIL_TAG_LOG_LIST_REQUEST_SUCCESS);

      yield put(
        accountUserActions.userToggleModal({
          name: 'accountUserTagLogModal',
          value: true,
          data: {
            ...customPayload,
            userTagLogList: result.data.userTagLogList,
          },
        }),
      );
    } catch (error) {
      toastMsg.error(accountUserToastMsg.GET_USER_DETAIL_TAG_LOG_LIST_REQUEST_ERROR, error);
    }
  });
}

export default function* accountUserSaga() {
  yield fork(fetchList);
}
